<template>
    <span>{{ this.count }}</span>
</template>

<script>
    export default {
        name: "Counter",
        props: ['to', 'format'],
        data() {
            return {
                interval: null,
                counter: {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                }
            };
        },
        mounted() {
            this.interval = setInterval(() => {
                const now = new Date().getTime();
                const distance = new Date(this.to).getTime() - now;
                this.counter.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                this.counter.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.counter.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.counter.seconds = Math.floor((distance % (1000 * 60)) / 1000);
            }, 1000);
        },
        computed: {
            count() {
              const format = this.format ? this.format : '%dT %hh %mmin %ss';
              return format
                  .replaceAll('%d', this.counter.days)
                  .replaceAll('%h', this.counter.hours)
                  .replaceAll('%m', this.counter.minutes)
                  .replaceAll('%s', this.counter.seconds)
                  ;
            }
        }
    }
</script>

<style scoped>

</style>
